const getModalRoot = (modalRoot) => {
    let rootElem;
    if (!modalRoot) {
        rootElem =
            document.getElementById('main') ||
                document.getElementById('react-root') ||
                document.getElementById('root');
    }
    else {
        rootElem =
            typeof modalRoot === 'string'
                ? document.getElementById(modalRoot)
                : modalRoot;
    }
    return rootElem !== null ? rootElem : document.body;
};
const getModalSize = (size) => {
    switch (size) {
        case 'small':
            return '450px';
        case 'large':
            return '1080px';
        case 'medium':
        default:
            return '600px';
    }
};

export { getModalRoot, getModalSize };
